class RegistrationWebinar {
    constructor(webinarShareRepo) {
        this.webinarShareRepo = webinarShareRepo;
    }
    async registrationWebinar(payload) {
        return await this.webinarShareRepo.registrationWebinar(payload);
    }
}
export default RegistrationWebinar;
